import { render, staticRenderFns } from "./processedDetail.vue?vue&type=template&id=1bd84837&"
import script from "./processedDetail.vue?vue&type=script&lang=js&"
export * from "./processedDetail.vue?vue&type=script&lang=js&"
import style0 from "./processedDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports